module.exports = __webpack_public_path__ + "static/abacusCH-694f00f06cbe863b737b5cdc5645c888.png";